export default __webpack_public_path__ + "static/media/linkedin.4a7e8e49.svg";